import { useState, useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import StripeContainer from "../components/StripeGateway/StripeContainer";
import Footer from "../components/Footer/Footer";
import axios from "axios";

function Ads() {
  const { channels, getAllChannels } = useStateContext();
  const [showItem, setShowItem] = useState(false);
  const [category, setCategory] = useState("");
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [ads, setAds] = useState(null);
  const [code, setCode] = useState("");

  const body = {
    amount: ads * 100,
    description: `Advertisement for ${category}`,
    channel: category,
    email: email,
    songLink: link,
    code: code,
  };

  useEffect(() => {
    getAllChannels();
  }, []);

  const handleLinkChange = (e) => {
    setLink(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleCodeChange = async (e) => {
    setCode(e.target.value);

    try {
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_API_SERVER}/check-promo-code/ad/${e.target.value}`
        )
        .then(
          (response) => {
            console.log(response);
            const result = response.data.found;
            console.log(result);
            if (result === true) {
              setAds(0);
            } else {
              const index = channels.findIndex(
                (item) => item.name === category
              );
              setAds(parseFloat(channels[index].ads));
            }
          },
          (error) => {
            alert(error);
          }
        );
    } catch (error) {
      alert(error);
    }
  };

  const handleCategoryChange = (e) => {
    setCategory(e.target.selectedOptions[0].label);
    setAds(parseFloat(e.target.value));
  };

  if (channels.length === 0) return <p>Loading...</p>;

  return (
    <>
      <div className="SubForm">
        <div className="block p-10 mx-8 bg-transparent border-1 border-indigo-900">
          {showItem ? (
            <StripeContainer
              body={body}
              url={`${process.env.REACT_APP_BACKEND_API_SERVER}/adspayment`}
              message="Congrats! Your song will pop up on the final page (after fans finish voting for each round). Clicking on the song image pop-up will take the audience directly to your Spotify link!"
            />
          ) : (
            <>
              <div className="flex justify-center items-center">
                <img
                  src="/images/vs.png"
                  className="w-1/4 h-auto mb-8"
                  alt="Sound Off Logo"
                />
              </div>
              <div className="flex text-center justify-center items-center">
                <h1 className="text-white uppercase font-bold text-2xl mb-8">
                  Advertisement
                </h1>
              </div>
              <div className="form-group mb-5">
                <input
                  value={link}
                  required
                  onChange={(e) => {
                    handleLinkChange(e);
                  }}
                  className="form-control block bg-black
                    w-full px-3 py-1.5 text-base font-normal                  
                    border-2 border-indigo-600 text-white
                    bg-clip-padding rounded transition ease-in-out  m-0
                  focus:border-green-600 focus:outline-none"
                  id=""
                  placeholder="Song Link (Spotify)"
                />
              </div>
              <div className="form-group mb-5">
                <input
                  type="email"
                  value={email}
                  required
                  onChange={(e) => {
                    handleEmailChange(e);
                  }}
                  className="form-control block bg-black
                    w-full px-3 py-1.5 text-base font-normal                  
                    border-2 border-indigo-600 text-white
                    bg-clip-padding rounded transition ease-in-out  m-0
                  focus:border-green-600 focus:outline-none"
                  id=""
                  placeholder="Email address"
                />
              </div>
              <div className="form-group mt-5">
                <select
                  required
                  onChange={(e) => {
                    handleCategoryChange(e);
                  }}
                  defaultValue=""
                  className="form-control block bg-black
                    w-full px-3 py-1.5 text-base font-normal                  
                    border-2 border-indigo-600 text-white
                    bg-clip-padding rounded transition ease-in-out  m-0
                  focus:border-green-600 focus:outline-none"
                >
                  <option value="" disabled>
                    Choose a channel
                  </option>
                  {channels &&
                    channels.map((cat) => (
                      <option value={cat.ads} name={cat.name} key={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="p-6 text-center">
                <p className="text-white font-bold text-lg">
                  ${ads != null ? ads : " ..."}
                </p>
              </div>

              <div className="form-group mb-6">
                <input
                  type="text"
                  value={code}
                  disabled={category === ""}
                  onChange={(e) => {
                    handleCodeChange(e);
                  }}
                  className={`${
                    category !== ""
                      ? "bg-black"
                      : "bg-gray-800 cursor-not-allowed"
                  }
                  form-control block 
                  w-full px-3 py-1.5 text-base font-normal                  
                  border-2 border-indigo-600 text-white
                  bg-clip-padding rounded transition ease-in-out  m-0
                focus:border-green-600 focus:outline-none`}
                  id=""
                  placeholder="Promo Code (Optional)"
                />
              </div>

              <div className="pt-3 text-center">
                <button
                  onClick={() => setShowItem(true)}
                  className="bg-blue-600 text-white rounded px-6 py-2"
                >
                  Register
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Ads;
